/** Written once here, so the page and what search engines read always match. */
export const LEGAL_CONTACT = "legal@yarn.watch";

export const LEGAL_SECTIONS: readonly { heading: string; text: string }[] = [
  {
    heading: "Unofficial",
    text: "Yarn is an unofficial, independent fan project. It is not affiliated with, endorsed by, "
      + "or sponsored by any author, publisher, film studio, or other rights holder of the works "
      + "it covers.",
  },
  {
    heading: "Who owns what",
    text: "All books, characters, names, artwork, and film images belong to their respective "
      + "owners, credited below. Yarn claims no ownership of them. Yarn does not include the text "
      + "of any book.",
  },
  {
    heading: "What Yarn is",
    text: "Yarn is a non-commercial visual guide that charts who is where and when in a story, in "
      + "our own words, for commentary and study. It is meant to go alongside the original works, "
      + "not replace them. Please read them.",
  },
  {
    heading: "Accuracy",
    text: "Yarn's summaries and timelines are written with the help of automated tools and can "
      + "contain mistakes. Dates may be best guesses.",
  },
  {
    heading: "Rights holders",
    text: `If you own rights in something shown here and want it changed or removed, email ${LEGAL_CONTACT} `
      + "with what it is and where it appears. We will respond promptly, and can remove images or "
      + "whole titles quickly.",
  },
];
